import { render, staticRenderFns } from "./EditCgroup.vue?vue&type=template&id=5be7c3a6&"
import script from "./EditCgroup.vue?vue&type=script&lang=js&"
export * from "./EditCgroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports